<script setup>
  const props = defineProps(['isActive']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <Wrapper wide :class="{ isActive }">
    <RawNav />
  </Wrapper>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  div {
    position: fixed;
    top: 0;

    height: calc(100vh + $mobile-header-offset);

    padding-top: calc($mobile-header-height + 5vh);
    padding-bottom: 3vh;

    background-color: $black;
    .light & {
      background-color: $white;
    }

    display: none;

    &.isActive {
      @include break-small {
        display: block;
      }
    }
  }

  nav {
    height: 100%;

    flex-direction: column;
    justify-content: space-between;

    font-size: px(20);

    padding-bottom: px(80);

    @include break-phone {
      font-size: 4vw;
    }

    :deep(ul) {
      flex-direction: column;
      gap: 4vh;

      .logo {
        display: none;
      }

      .tickets {
        align-self: center;

        @include break-phone {
          align-self: stretch;
        }
      }
    }
  }
</style>
